import { Fragment, h } from "preact";
import { Container, Spacer } from "../material";
import { formatCurrency, getNumberOfDays } from "../services/utils";
import { calculateEntryPrice, useShoppingBasket } from "../services/shoppingbasket";
import { useRouter } from "preact-router";
import { getProductUrl } from "../services/navigation";
import { AmountEditor } from "./amounteditor";
import "./shoppingbasket.scss";
import { data } from "../services/data";

export function ShoppingBasket() {
    const { basket, setBasket, setOrIncrementProductCount } = useShoppingBasket();
    const totalprice = basket.entries.reduce((total, entry) => total + calculateEntryPrice(entry).total, 0);

    const days = Math.max(1, !!basket.fromDate && !!basket.toDate ? (getNumberOfDays(basket.fromDate, basket.toDate) + 1) : 1);

    useRouter();
    const isOnCheckout = document.location.pathname.startsWith("/checkout"); // hack :)

    return (
        <Container class="shoppingbasket grow column">
            <div>
                <h2>Kurv</h2>
                {
                    basket.entries.length == 0 &&
                    <div>Kurven er tom.</div>
                }
                {
                    basket.entries.length > 0 &&
                    <div class="entries">
                        {
                            basket.entries.map(entry => (
                                <Fragment>
                                    <div class="entry">
                                        <div>{
                                            entry.product.isAddon
                                                ? entry.product.title
                                                : <a href={getProductUrl(entry.product)}>{entry.product.title}</a>
                                        }</div>
                                        <div>{formatCurrency(calculateEntryPrice(entry).itemtotal)}</div>
                                        <div>
                                            <AmountEditor value={entry.count} onChange={number => setOrIncrementProductCount(entry.product, number, undefined)} />
                                        </div>
                                    </div>
                                    {
                                        entry.product.mandatoryAddons?.map(addonId => data.products.find(n => n.id == addonId))
                                            .filter(n => !!n)
                                            .map(addon => (
                                                <div class="entry">
                                                    <div>{addon!.title}</div>
                                                    <div>{formatCurrency((addon!.itemPrice ?? 0) * entry.count)}</div>
                                                    <div></div>
                                                </div>
                                            ))
                                    }
                                </Fragment>
                            ))
                        }
                    </div>
                }
                <Spacer />
                {
                    (!basket?.fromDate || !basket?.toDate) &&
                    <Fragment>
                        <hr />
                        <p>Viste priser er for en enkelt dag. Vælg leje-periode på checkout for at se priser / rabatter for flere dage.</p>
                    </Fragment>
                }
                <hr />
                <p>
                    <div class="priceholder">
                        <span>Pris i alt</span>
                        <Spacer />
                        <span>{formatCurrency(totalprice)}</span>
                    </div>
                    {
                        basket.entries.length > 0 &&
                        <div class="vatholder">
                            <span>Heraf moms</span>
                            <Spacer />
                            <span>{formatCurrency(totalprice * 0.2)}</span>
                        </div>
                    }
                    {
                        !isOnCheckout && basket.entries.length > 0 &&
                        <div>
                            {
                                // <Button size="small" class="wide">Forespørg</Button>
                            }
                            <a class="linkbutton" href="/checkout">Forespørg</a>
                        </div>
                    }
                    <footer><b>Bemærk!</b> De beregnede priser er vejledende og kan variere fra de endelige priser.
                    </footer>
                </p>
            </div>
        </Container >
    );
}
